import apiBearer from '../api-bearer';
import type { AgreementsActiveResponse } from './agreements.model';

export const getAgreementsActive = async (): Promise<AgreementsActiveResponse> => {
  const { data } = await apiBearer.get<AgreementsActiveResponse>(`/agreements/active`);
  return data;
};
